export default "__VITE_ASSET__Ftjq2XHN__"